import styled from "styled-components";

export const FileUploadContainer = styled.section`
  position: relative;
  min-height: 118px;
  margin: 8px 0 8px;
  border: 1px dashed #b9d7ec;
  padding: 18px 16px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(240, 247, 252, 0.72)),
    #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.78);
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;

  &:hover {
    border-color: #3078ad;
    box-shadow: inset 0 0 0 1px rgba(48, 120, 173, 0.08), 0 10px 24px rgba(3, 64, 123, 0.08);
    transform: translateY(-1px);
  }
`;

export const FormField = styled.input`
  font-size: 18px;
  display: block;
  width: 100%;
  border: none;
  text-transform: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;

  &:focus {
    outline: none;
  }
  &:drop {
    opacity: 1;
  }
`;

export const InputLabel = styled.label`
  top: -21px;
  font-size: 13px;
  color: black;
  left: 0;
  position: absolute;
`;

export const DragDropText = styled.p`
  max-width: 280px;
  color: #334155;
  font-size: 0.82rem;
  line-height: 1.45;
  font-weight: 800;
  letter-spacing: 0.04em;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
`;

export const UploadFileBtn = styled.button`
  box-sizing: border-box;
  appearance: none;
  background: linear-gradient(135deg, #03407b, #075a9f 55%, #0ea5e9);
  border: 0;
  cursor: pointer;
  font-size: 0.84rem;
  line-height: 1;
  padding: 0 18px;
  min-height: 36px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 900;
  border-radius: 999px;
  color: #ffffff;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
  font-family: "Open Sans", sans-serif;
  width: auto;
  min-width: 142px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 8px 18px rgba(3, 64, 123, 0.25);

  &:before {
    content: "";
    position: absolute;
    top: -70%;
    left: -55%;
    width: 42%;
    height: 240%;
    background: rgba(255, 255, 255, 0.34);
    transform: rotate(25deg);
    z-index: -1;
    transition: left 420ms ease;
  }

  svg {
    font-size: 0.95rem;
    transition: transform 180ms ease;
  }

  i {
    font-size: 22px;
    margin-right: 5px;
    border-right: 2px solid;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  @media only screen and (max-width: 350px) {
    width: 100%;
  }

  &:hover {
    color: #fff;
    outline: 0;
    filter: saturate(1.08);
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(3, 64, 123, 0.31);

    &:before {
      left: 118%;
    }

    svg {
      transform: translateY(-1px) scale(1.08);
    }
  }

  &:focus {
    outline: 0;
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.24), 0 8px 18px rgba(3, 64, 123, 0.25);
  }

  &:disabled {
    opacity: 0.4;
    filter: grayscale(100%);
    pointer-events: none;
  }
`;

export const FilePreviewContainer = styled.article`
  margin: 8px 0 8px;
  text-align: left;

  & > span {
    display: block;
    margin-bottom: 8px;
    color: #475569;
    font-size: 0.76rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;

export const PreviewList = styled.section`
  display: grid;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;

  @media only screen and (max-width: 400px) {
    flex-direction: column;
  }
`;

export const FileMetaData = styled.div`
  display: ${(props) => (props.isImageFile ? "none" : "grid")};
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  position: static;
  min-height: 46px;
  padding: 9px 10px 9px 12px;
  border-radius: 9px;
  color: #0f172a;
  font-weight: 800;
  background: linear-gradient(180deg, #ffffff, #f8fbff);
  border: 1px solid #dbe8f3;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);

  & > span {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
    overflow: hidden;
    color: #03407b;
    font-size: 0.78rem;
    line-height: 1.3;
    text-overflow: ellipsis;
    white-space: nowrap;

    svg {
      flex: 0 0 auto;
      color: #0ea5e9;
    }
  }

  aside {
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    color: #64748b;

    span {
      min-width: 44px;
      padding: 3px 7px;
      border-radius: 999px;
      color: #475569;
      background: #eef4f9;
      border: 1px solid #dce8f2;
      font-size: 0.72rem;
      font-weight: 900;
      text-align: center;
      text-transform: uppercase;
    }

    svg {
      width: 28px;
      height: 28px;
      padding: 7px;
      color: #dc2626;
      background: #fff1f2;
      border: 1px solid #fecdd3;
      border-radius: 8px;
      transition: transform 160ms ease, background 160ms ease;
    }

    svg:hover {
      color: #ffffff;
      background: #dc2626;
      transform: translateY(-1px);
    }
  }
`;

export const RemoveFileIcon = styled.i`
  cursor: pointer;

  &:hover {
    transform: scale(1.3);
  }
`;

export const PreviewContainer = styled.section`
  padding: 0;
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-sizing: border-box;

  & > div:first-of-type {
    height: auto;
    position: relative;
  }

  @media only screen and (max-width: 750px) {
    width: 30%;
  }

  @media only screen and (max-width: 500px) {
    width: 100%;
    justify-content: center;
  }

  @media only screen and (max-width: 400px) {
    width: 100%;
    padding: 0 0 0.4em;
  }
`;

export const ImagePreview = styled.img`
  border-radius: 6px;
  width: 100%;
  height: 100%;
`;
